import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Currency conversion utilities
// Default tasa (exchange rate USD to BS)
const DEFAULT_TASA = 1;

/**
 * Convert USD to BS
 */
export function usdToBs(usd: number, tasa: number | null | undefined): number {
  return usd * (tasa || DEFAULT_TASA);
}

/**
 * Convert BS to USD
 */
export function bsToUsd(bs: number, tasa: number | null | undefined): number {
  return bs / (tasa || DEFAULT_TASA);
}

/**
 * Format price with currency symbol
 */
export function formatPrice(amount: number, currency: 'USD' | 'BS'): string {
  if (currency === 'USD') {
    return `${amount.toFixed(2)}`;
  }
  return `Bs ${amount.toFixed(2)}`;
}

/**
 * Get the converted price in the other currency as a string
 */
export function getConvertedPrice(
  amount: number,
  currency: 'USD' | 'BS',
  tasa: number | null | undefined,
): string {
  const converted =
    currency === 'USD' ? usdToBs(amount, tasa) : bsToUsd(amount, tasa);
  const otherCurrency = currency === 'USD' ? 'BS' : 'USD';
  return formatPrice(converted, otherCurrency);
}
